import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BankAccountTypesService {
  private apiUrl = environment.apiUrl + '/bank_account_types/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  get(): Observable<any> {
    let params = new HttpParams();
    return this.http.get(`${this.apiUrl}get`, { params });
  }
  
  getById(id: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl + 'get/' + id)
  }
  update(id: string, userData: any): Observable<any> {
    console.log(userData)
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }
  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', userData);
  }
}
